const carRental = {
  carRental: "تاجير سيارة", // translated 
  carRentals: "تأجير السيارات", // translated 
  pickUpPoint: "نقطة الالتقاط", // translated 
  dropOffPoint: "نقطة النزول", // translated 
  pleaseSelectAPickUpPoint: "الرجاء تحديد نقطة الالتقاط", // translated 
  pickUpDate: "اختر تاريخا", // translated 
  dropOffDate: "تاريخ النزول", // translated 
  pickUp: "يلتقط", // translated 
  dropOff: "إنزال", // translated 
  edit: "يحرر", // translated 
  fuelPolicy: "سياسة الوقود", // translated 
  pickUpLocation: "اختر موقعا", // translated 
  mileage: "عدد الأميال", // translated 
  transmission: "الانتقال", // translated 
  airCondition: "تكييف الهواء", // translated 
  minimumAge: "الحد الإدنى للعمر", // translated 
  maximumAge: "الحد الأقصى للعمر", // translated 
  providerAddress: "عنوان المزود", // translated 
  providerPhone: "هاتف المزود", // translated 
  driverInfo: "معلومات السائق", // translated 
  driversInfo: "معلومات السائق", // translated 
  differentDropOff: "النزول في مكان مختلف", // translated 
  maxPassengers: "ماكس الركاب", // translated 
  budget: "ميزانية", // translated 
  provider: "مزود", // translated 
  carModel: "طراز السيارة", // translated 
  numOfDoors: "عدد الأبواب", // translated 
  fuelType: "نوع الوقود", // translated 
  driverAge: "العمر السائق", // translated 
  enterValidDriversAge: "الرجاء إدخال عمر السائق الصحيح.", // translated 
  workingHours: "ساعات العمل", // translated 
  driverNationality: "جنسية السائق", // translated 
  nationalityIsRequired: "الجنسية مطلوبة", // translated 
  carRentalRate: "سعر تأجير السيارات", // translated 
  dueNow: "مستحق الآن", // translated 
  duePickUp: "مستحق عند الاستلام", // translated 
  toViewOfferPDF:
    "لعرض وثيقة PDF تحتوي على جميع شروط الإيجار لهذا العرض، من فضلك", // translated 
  toViewTermsAndCondPDF:
    "للاطلاع على شروط وأحكام CARNECT المعمول بها، من فضلك", // translated 
  carRentalsNotFound:
    "لم نتمكن من العثور على أي نتائج لتأجير السيارات. نحن نأسف للإزعاج", // translated 
};




export default carRental;
